import CarrotImage from '@assets/icons/carrot.svg';
import React from 'react';
import { Button, Props as ButtonProps } from '@/components/button';
import { PageContainer } from '@/components/page-container';
import { SCREEN_PADDING, TYPOGRAPHY } from '@/styles';
import { StyleSheet, Text, View } from 'react-native';
import { useTheme } from '@/contexts/theme-context';

interface Props {
  buttonProps: ButtonProps;
  footerText: string;
  subtitle: string;
  title: string;
}

export const ForceUpgradeContent: React.FC<Props> = ({
  buttonProps,
  footerText,
  subtitle,
  title,
}) => {
  const theme = useTheme();
  return (
    <PageContainer showNavigationHeader={false}>
      <View style={styles.content}>
        <View style={styles.container}>
          <CarrotImage accentFill={theme.colors.accent} />
          <Text style={[TYPOGRAPHY.h2, styles.title]}>{title}</Text>
          <Text style={[TYPOGRAPHY.medium, styles.subtitle]}>{subtitle}</Text>
          <Button containerStyle={styles.buttonContainer} {...buttonProps} />
          <Text style={[TYPOGRAPHY.small, styles.info]}>{footerText}</Text>
        </View>
      </View>
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    alignSelf: 'stretch',
    marginBottom: 16,
  },
  container: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  content: {
    alignItems: 'center',
    flex: 1,
    marginHorizontal: SCREEN_PADDING,
    maxWidth: 400,
  },
  info: {
    lineHeight: 21,
    textAlign: 'center',
  },
  subtitle: {
    lineHeight: 24,
    marginBottom: 16,
    textAlign: 'center',
  },
  title: {
    marginVertical: 8,
    textAlign: 'center',
  },
});
